import React from 'react';

import * as analytics from 'analytics/Analytics';
import {REQUESTS_V2_ANALYTICS_ACTIONS} from 'constants/analytics-products/RequestsV2AnalyticsConstants';
import {ActionMethod, ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import RequestV2SubmissionDocument from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionDocument';
import useOnMount from 'ui-library/hooks/useOnMount';

interface RequestV2SubmissionDocumentTabViewProps {
  requestV2SubmissionId: string;
  onSubmissionAddProgressAndOutputsTab: () => void;
}

export default function RequestV2SubmissionDocumentTabView(
  props: RequestV2SubmissionDocumentTabViewProps
): JSX.Element {
  useOnMount(() => {
    analytics.trackEvent(REQUESTS_V2_ANALYTICS_ACTIONS.CLICKED_REQUEST_V2_REQUEST_TAB, {
      request_v2_submission_id: props.requestV2SubmissionId,
      action_origin: ActionOrigin.REQUEST_V2_SUBMISSION,
      action_method: ActionMethod.BUTTON_CLICK,
    });
  });

  return (
    <div className="react-tab-container" style={{padding: 0}}>
      <RequestV2SubmissionDocument {...props} />
    </div>
  );
}
